import TabsScreen from 'components/tabs-screen';
import styles from './styles.module.scss';
import useBoundStore from 'store';
import { APIUserType } from 'api/types';
import ApartmentFavorites from '../apartment-favorites';
import { EFavoritesType } from 'lib/types';

const ApartmentFavoritesMain: React.FC = () => {
  const user = useBoundStore.getState().user;
  const defaultTab = useBoundStore.getState().tabFavoritesSelected;
  const setDefaultTab = useBoundStore((s) => s.setTabFavoriteSelected);

  const isClient = user?.type === APIUserType.CLIENT;

  const handleChangeTab = (value: number) => {
    setDefaultTab(value);
  };

  const getTabs = () => {
    if (isClient) {
      return [
        {
          title: 'Список от риелтора',
          content: <ApartmentFavorites type={EFavoritesType.Customer} />,
        },
      ];
    }

    return [
      { title: 'Личные', content: <ApartmentFavorites type={EFavoritesType.Personal} /> },
      { title: 'Совместные', content: <ApartmentFavorites type={EFavoritesType.Shared} /> },
      { title: 'Клиентские', content: <ApartmentFavorites type={EFavoritesType.Customer} /> },
    ];
  };

  return (
    <>
      <TabsScreen
        title={'Избранные обьекты'}
        noMarginForFloatingButtons
        footerClassName={styles.footer}
        tabs={getTabs()}
        defaultTab={defaultTab}
        onTabChange={handleChangeTab}
      />
    </>
  );
};

export default ApartmentFavoritesMain;
